import React, {useEffect, useState} from "react";
import { Outlet } from "react-router-dom";

import styles from "./Layout.module.css";
import {
    getAccessTokenFromStorage, getTenantNameFromStorage,
    setAccessTokenInStorage,
    setTenantNameInStorage
} from "../../helpers/accessTokenHelpers";

const initialApproach = getTenantNameFromStorage() === "quake" ? "rrr-elser": "rrr-elser";

export const ApproachContext = React.createContext<string>(initialApproach); 

const Layout = () => {
    
    useEffect(() => {
        //if token is in the query string set it in storage then remove it.
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        if(token) {
            setAccessTokenInStorage(token);
            setAccessToken(token);
            window.history.replaceState({}, document.title, "/");
        }
    }, []);
    
    const [tenantName, setTenantName] = useState<string>(getTenantNameFromStorage() ?? "");
    const [directLogin, setDirectLogin] = useState<boolean>(false);
    const [accessToken, setAccessToken] = useState<string | null>(getAccessTokenFromStorage());
    const [currentApproach, setCurrentApproach] = useState<string>(initialApproach);

    const signIn = (e: any) => {
        e?.preventDefault();
        let additionalParameters = directLogin ? "&authentication_mode=directlogon" : "";
        setTenantNameInStorage(tenantName)
        window.location.href = `https://auth.seismic.com/tenants/${tenantName}/connect/authorize?response_type=code&scope=openid+email+profile+seismic.self.view+seismic.search+download+library+reporting+offline_access&client_id=c58e9dc7-822a-45bb-ae66-31f8efc96697&redirect_uri=https://tstrader-sandbox.glitch.me/seismic/proxyRedirect&state=${window.location.href}${additionalParameters}`;
    }

    const signOut = (e: any) => {
        setAccessTokenInStorage(null);
        setAccessToken(null);
    }
    
    const setTheApproach = (newApproach: string) => {
        setCurrentApproach(newApproach);
    }
    
    return (
        <div className={styles.layout}>
            <header className={styles.header} role={"banner"}>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <div><img src="./image.png" alt="logo" /><br/>{accessToken && tenantName === "quake" && <small>Powered by published quake library content from 12/11/2023</small>}</div>
                    {accessToken && <div style={{display: "flex", gap: "8px"}}>
                        {tenantName === "quake" && <>
                        <a className={`${currentApproach === "rrr-elser" ? "approach-selected" : "approach-not-selected"}`} onClick={()=>setTheApproach("rrr-elser")}>GenAI Search</a> |
                            <a className={`${currentApproach === "rrr-seismic-elastic" ? "approach-selected" : "approach-not-selected"}`} onClick={()=>setTheApproach("rrr-seismic-elastic")}>Seismic Search</a> |
                            <a className={`${currentApproach === "rrr-seismic-elastic-google" ? "approach-selected" : "approach-not-selected"}`} onClick={()=>setTheApproach("rrr-seismic-elastic-google")}>Seismic Search Bison</a> |
                            <a className={`${currentApproach === "api-seismic-snippets" ? "approach-selected" : "approach-not-selected"}`} onClick={()=>setTheApproach("api-seismic-snippets")}>SeismicSnippets</a> |
                            <a className={`${currentApproach === "rrr-openai" ? "approach-selected" : "approach-not-selected"}`} onClick={()=>setTheApproach("rrr-openai")}>OpenAI</a> |
                            <a className={`${currentApproach === "rrr-google" ? "approach-selected" : "approach-not-selected"}`} onClick={()=>setTheApproach("rrr-google")}>Google</a> |
                            <a className={`${currentApproach === "rrr-ibm" ? "approach-selected" : "approach-not-selected"}`} onClick={()=>setTheApproach("rrr-ibm")}>IBM</a>
                        </>}
                    </div>}
                    {accessToken && <div style={{padding: "24px"}}><a style={{cursor: "pointer"}} onClick={signOut}>Sign Out of {tenantName}</a></div>}
                </div>
            </header>

            {accessToken === null ? <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "80vh"}}>
                <div style={{height: "186px", width: "400px", border: "1px solid #cfd4da", borderRadius: "8px", backgroundColor: "white"}}>
                    <div>
                        <div style={{borderBottom: "1px solid #cfd4da", padding: "16px", fontSize: "16px", fontWeight: 600, color: "rgb(52, 58, 64)", display: "flex", alignItems: "center", gap: "8px"}}>
                            <img alt="logo" src="./favicon.ico" />
                            <div>Knowledge Powered by Aura - Sign In</div>
                        </div>
                        <div style={{padding: "8px", fontSize: "14px", color: "rgb(52, 58, 64)"}}>
                            <div style={{paddingTop: "16px", paddingBottom: "8px", fontSize: "12px", display: "flex", alignItems: "center", gap: "8px"}}>
                                <label>Tenant:</label>
                                <input style={{width: "348px"}} type="text" onChange={(e)=>setTenantName(e.target.value)} value={tenantName} />
                            </div>
                            <div style={{paddingTop: "0px", paddingBottom: "16px", fontSize: "12px", display: "flex", alignItems: "center", gap: "8px"}}>
                                <label>Direct Login:</label>
                                <input type="checkbox" checked={directLogin} onChange={()=>setDirectLogin(!directLogin)} />
                            </div>
                            <div>
                                <button onMouseOver={(e)=>e.currentTarget.style.backgroundColor = "rgb(0, 101, 255)"} onMouseLeave={(e)=>e.currentTarget.style.backgroundColor = "rgb(7, 9, 141)"} style={{cursor: "pointer", width: "100%", height: "32px", backgroundColor: "rgb(7, 9, 141)", color: "white", fontSize: "14px", fontWeight: "600", border: "none", borderRadius: "4px"}} onClick={signIn}>Sign In</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> : 
                <ApproachContext.Provider value={currentApproach}>
                    <Outlet />
                </ApproachContext.Provider>}
            </div>
    );
};

export default Layout;
